import { render } from "./MathfieldDetails.vue?vue&type=template&id=29554b8c&scoped=true"
import script from "./MathfieldDetails.vue?vue&type=script&lang=js"
export * from "./MathfieldDetails.vue?vue&type=script&lang=js"

import "./MathfieldDetails.vue?vue&type=style&index=0&id=29554b8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29554b8c"]])

export default __exports__